import React from 'react'

export default function HighlighText({text}) {
  return (
    <span className='font-bold text-richblue-500'>
        {" "}
     {text}
    </span>
  )
}
